import React from 'react';
import PropTypes from 'prop-types';

import './Slider.scss';

const propTypes = {
    callback: PropTypes.func,
    customRange: PropTypes.number,
    animate: PropTypes.string,
    isVertical: PropTypes.bool,
    dark: PropTypes.bool,
};

const defaultProps = {
    callback: null,
    customRange: null,
    animate: null,
    isVertical: false,
    dark: false,
};

class Slider extends React.Component {
    constructor(props) {
        super(props);

        this.slider = React.createRef();
        this.sliderThumb = React.createRef();
        this.sliderTrackFilled = React.createRef();
        this.state = {
            thumbFocus: false,
        };

        this.callback = props.callback;
        this.customRange = props.customRange;
        this.isVertical = props.isVertical;
    }

    onThumbMoveStart = () => {
        this.setState({ thumbFocus: true });

        document.addEventListener('mousemove', this.onThumbMove);
        document.addEventListener('mouseup', this.onThumbMoveEnd);

        document.addEventListener('touchmove', this.onThumbMove);
        document.addEventListener('touchend', this.onThumbMoveEnd);
    };

    getThumbPosition = (event) => {
        let thumbPosition;

        if (this.isVertical) {
            thumbPosition = (event.touches ? event.touches[0].clientY : event.clientY) - this.slider.current.getBoundingClientRect().top;
        } else {
            thumbPosition = (event.touches ? event.touches[0].clientX : event.clientX) - this.slider.current.getBoundingClientRect().left;
        }

        return thumbPosition;
    };

    onThumbMove = (event) => {
        let newPosition = this.getThumbPosition(event);
        let newPositionPct;
        const sliderWidth = this.slider.current.offsetWidth;
        const sliderHeight = this.slider.current.offsetHeight;
        const thumbSize = this.sliderThumb.current.offsetWidth;
        const rightEdge = sliderWidth - thumbSize;
        const bottomEdge = sliderHeight - thumbSize;

        this.sliderReachedEnd = false;

        if (this.isVertical) {
            if (newPosition > bottomEdge) {
                newPosition = bottomEdge;
            }

            if (newPosition <= 0) {
                newPosition = 0;
                this.sliderReachedEnd = true;
            }

            this.sliderThumb.current.style.top = `${newPosition}px`;
            this.sliderTrackFilled.current.style.height = `${bottomEdge - newPosition}px`;

            newPositionPct = (100 * (bottomEdge - newPosition + thumbSize / 2)) / sliderHeight;
        } else {
            if (newPosition < 0) {
                newPosition = 0;
            }

            if (newPosition > rightEdge) {
                newPosition = rightEdge;
                this.sliderReachedEnd = true;
            }

            this.sliderThumb.current.style.left = `${newPosition}px`;
            this.sliderTrackFilled.current.style.width = `${newPosition}px`;

            newPositionPct = (100 * (newPosition + thumbSize / 2)) / sliderWidth;
        }

        if (this.customRange !== null && newPositionPct >= this.customRange) {
            this.sliderReachedEnd = true;
        }
    };

    onThumbMoveEnd = () => {
        this.setState({ thumbFocus: false });

        if (this.sliderReachedEnd) {
            this.callback();
        }

        document.removeEventListener('mousemove', this.onThumbMove);
        document.removeEventListener('mouseup', this.onThumbMoveEnd);

        document.removeEventListener('touchmove', this.onThumbMove);
        document.removeEventListener('touchend', this.onThumbMoveEnd);
    };

    render() {
        const { thumbFocus } = this.state;
        const { animate, isVertical, dark } = this.props;
        const classAnimate = animate ? `animate-${animate}` : '';
        const classThumbFocus = thumbFocus ? 'focus' : '';
        const classVertical = isVertical ? 'vertical' : '';
        const classDark = dark ? 'dark' : '';

        return (
            <div className={['Slider', classAnimate, classVertical, classDark].join(' ')}>
                <div className="Slider__container" ref={this.slider}>
                    <div className="Slider__track">
                        <div ref={this.sliderTrackFilled} className="Slider__track__filled" />
                    </div>
                    <button
                        aria-label="Slider thumb"
                        type="button"
                        ref={this.sliderThumb}
                        onMouseDown={this.onThumbMoveStart}
                        onTouchStart={this.onThumbMoveStart}
                        className={['Slider__thumb', classThumbFocus].join(' ')}
                    />
                </div>
            </div>
        );
    }
}

Slider.propTypes = propTypes;
Slider.defaultProps = defaultProps;

export default Slider;
